import cashBookInstance from '../../cashBook/instance'

const deleteCategory = (categoryId) => {
	return cashBookInstance.delete(`/cash-book/categories/${categoryId}`)
}

export default deleteCategory
